import * as React from "react"
import { cn } from "@/lib/utils"

export interface PairingIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels
   * @default 18
   */
  size?: number
}

/**
 * Pairing icon as SVG (NFC scan symbol)
 *
 * This icon represents the pairing/connection action in the ANYW3AR app.
 *
 * @example
 * ```tsx
 * <PairingIcon />
 * <PairingIcon size={16} className="text-white" />
 * ```
 */
export const PairingIcon = React.forwardRef<SVGSVGElement, PairingIconProps>(
  ({ size = 18, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 17 11"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("inline-flex shrink-0", className)}
        aria-hidden="true"
        {...props}
      >
        <path d="M.4,5.5c0-1,.2-1.9.5-2.8.4-.9.9-1.7,1.5-2.4.1-.1.3-.2.5-.2.2,0,.3,0,.4.2.1.1.2.3.1.4,0,.2,0,.3-.2.5-.5.6-1,1.2-1.2,2-.3.7-.4,1.5-.4,2.4s.1,1.6.4,2.4c.3.7.7,1.4,1.2,2,.1.1.2.3.2.5,0,.2,0,.3-.1.4-.1.1-.3.2-.4.2s-.3,0-.5-.2c-.7-.7-1.2-1.5-1.5-2.4-.4-.9-.5-1.8-.5-2.8ZM2.6,5.5c0-.7.1-1.4.4-2,.2-.6.6-1.2,1.1-1.7.1-.1.3-.2.5-.2.2,0,.3,0,.4.2.1.1.2.3.1.4,0,.2,0,.3-.2.5-.3.4-.6.8-.8,1.3-.2.5-.3,1-.3,1.6s0,1.1.3,1.6c.2.5.4.9.8,1.3.1.1.2.3.2.5,0,.2,0,.3-.1.4-.1.1-.3.2-.4.2-.2,0-.3,0-.5-.2-.5-.5-.8-1.1-1.1-1.7-.2-.6-.4-1.3-.4-2ZM4.8,5.5c0-.4,0-.8.2-1.2.1-.4.3-.7.6-1,.1-.2.3-.2.5-.3.2,0,.3,0,.5.2.1.1.2.3.1.4,0,.1,0,.3-.2.5-.1.2-.2.4-.3.6,0,.2-.1.5-.1.7s0,.5.1.7c0,.2.2.4.3.6.1.2.2.3.2.5,0,.1,0,.3-.1.4-.1.1-.3.2-.5.2-.2,0-.3,0-.5-.3-.2-.3-.4-.6-.6-1-.1-.4-.2-.8-.2-1.2ZM12.2,5.5c0,.4,0,.8-.2,1.2-.1.4-.3.7-.6,1-.1.2-.3.2-.5.3-.2,0-.3,0-.5-.2-.1-.1-.2-.3-.1-.4,0-.2,0-.3.2-.5.1-.2.2-.4.3-.6,0-.2.1-.5.1-.7s0-.5-.1-.7c0-.2-.2-.4-.3-.6-.1-.2-.2-.3-.2-.5,0-.2,0-.3.1-.4.1-.1.3-.2.5-.2.2,0,.3,0,.5.3.2.3.4.7.6,1,.1.4.2.8.2,1.2ZM14.4,5.5c0,.7-.1,1.4-.4,2-.2.6-.6,1.2-1,1.7-.1.1-.3.2-.5.2-.2,0-.3,0-.5-.2-.1-.1-.2-.3-.1-.4,0-.2,0-.3.2-.5.3-.4.6-.8.8-1.3.2-.5.3-1,.3-1.6s0-1.1-.3-1.6c-.2-.5-.4-.9-.8-1.3-.1-.1-.2-.3-.2-.5,0-.2,0-.3.1-.4.1-.1.3-.2.5-.2.2,0,.3,0,.5.2.5.5.8,1.1,1,1.7.2.6.4,1.3.4,2ZM16.6,5.5c0,1-.2,1.9-.5,2.8-.4.9-.9,1.7-1.5,2.4-.1.1-.3.2-.5.2s-.3,0-.4-.2c-.1-.1-.2-.3-.1-.4,0-.2,0-.3.2-.5.5-.6,1-1.2,1.2-2,.3-.7.4-1.5.4-2.4s-.1-1.6-.4-2.4c-.3-.7-.7-1.4-1.2-2-.1-.1-.2-.3-.2-.5,0-.2,0-.3.1-.4.1-.1.3-.2.4-.2.2,0,.3,0,.5.2.7.7,1.2,1.5,1.5,2.4.4.9.5,1.8.5,2.8ZM7.3,5.5c0-.2,0-.4.2-.6.1-.2.3-.3.4-.4.2-.1.4-.2.6-.2.3,0,.6.1.8.4.2.2.3.5.3.8s0,.4-.2.6c-.1.2-.2.3-.4.4-.2.1-.4.2-.6.2s-.4,0-.6-.2c-.2-.1-.3-.3-.4-.4-.1-.2-.2-.4-.2-.6Z" />
      </svg>
    )
  }
)

PairingIcon.displayName = "PairingIcon"
